import { ChangeDetectorRef, Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocumentService } from 'src/app/services/document/document.service';
import { DocumentMetadata } from 'src/app/utils/interfaces/new/DocumentMetadata';
import { DisplayContentData, GEDViewerComponent } from '../gedviewer/gedviewer.component';

@Component({
  selector: 'app-gedimage-viewer',
  templateUrl: './gedimage-viewer.component.html',
  styleUrls: ['./gedimage-viewer.component.scss']
})
export class GEDImageViewerComponent extends GEDViewerComponent {

  urlDocument: SafeResourceUrl;

  constructor(
    protected domSanitizer: DomSanitizer
  ) {
    super(domSanitizer);
  }

  public print(document: DisplayContentData): void {
    const voucherSourcetoPrint = (source) => {
      return `<html><head><script>function step1(){
              setTimeout('step2()', 10);}
              function step2(){window.print();window.close()}
              </script></head><body onload='step1()'>
              <img src='${source}' /></body></html>`;
    };

    const pagelink = 'about:blank';
    const pwa = window.open(pagelink, '_new');
    pwa.document.open();
    pwa.document.write(voucherSourcetoPrint(document.data));
    pwa.document.close();
  }

  public download(document: DisplayContentData): void {
    fetch(document.data)
      .then(resp => resp.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = document.fileName;
        window.document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        window.document.body.removeChild(a);
      });
  }

  public async setData(data: DisplayContentData): Promise<void> {
    setTimeout(async () => {
      await fetch(data.data)
        .then(resp => resp.blob())
        .then(blob => {
          this.urlDocument = this.sanitizeUrl(window.URL.createObjectURL(blob));
        });
      this._data = data;
    }, 0);
  }
}
